var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"canvas",staticClass:"canvas",style:({width: (_vm.roadWidth + "px"), height: (_vm.roadHeight + "px")})})}
var staticRenderFns = []

export { render, staticRenderFns }